import { render } from "./KoruTinyBrowser.vue?vue&type=template&id=983bd078&ts=true"
import script from "./KoruTinyBrowser.vue?vue&type=script&lang=ts"
export * from "./KoruTinyBrowser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__